import { List } from "immutable";
import { StagePermissionsPipeline } from "utilities";
import { RESET_STORE_ACTION, USER_ACTIONS, 
    // CASE_ACTIONS
} from "../../constants";
import { StagePermissionsListRecord } from "../../records";

const DEFAULT_INITIAL_STATE = new StagePermissionsListRecord();

export default (state = DEFAULT_INITIAL_STATE, { type, payload }) => {
    switch (type) {
    case USER_ACTIONS.FETCHED_USER: {
        const participatedStages = payload.user.participated_stages.map(_ => {
            if(!_.id) {
                _.id = 0;
            }
            _.key = `${_.id}|participated`;
            return _;
        });
        const allStages = payload.user.stage_permissions.concat(participatedStages).sort((a,b) => {
            if(a.ordering > b.ordering) {
                return 1;
            } else if(a.ordering < b.ordering) {
                return -1;
            }
        });
            let final_stages = allStages;
            final_stages = final_stages.map(_ => ({
                ..._,
                stage_name: _.stage_name.includes("Progcap")
                    ? _.stage_name.replace('Progcap', 'Progfin')
                    : _.stage_name
            })); 
        const newState = StagePermissionsPipeline.run(
            new List(final_stages)
        );
        return state
            .set("data", newState.data)
            .set("status", newState.status);
    }
    case RESET_STORE_ACTION:
        return DEFAULT_INITIAL_STATE;
    case "LOGOUT":
        return DEFAULT_INITIAL_STATE;
    default:
        return state;
    }
};
